import { FC } from 'react'
import { styles } from './styles'

export const Error: FC = ({ children }) => <div css={styles.container}>{children}</div>
